import { Component } from 'react';
import { EventifyMixin } from '../../../Shared/Eventify';

export class ComponentListen<A = {}, B = {}> extends EventifyMixin(Component)<A, B> {}
